import { API_URL, THEME_COLOR } from '../../constant';
import React, {useEffect, useState} from 'react';
import "./Warehouse.css";
import { Typography } from '@mui/material';
import RecommendIcon from '@mui/icons-material/Recommend';
let Warehouse = (props)=>{
    const [warehouses, setWarehouses] = useState([])
    const [availableStockConfig, setAvailStockConfig] = useState({});

    const changeIsOpenWarehouse = (val) => {
        props.changeIsOpenWarehouse(val)
    }

    const ClickWarehouse = (warehouse) =>{
        props.setWarehouse({
            ID: warehouse.WarehouseID,
            CompanyID: warehouse.CompanyID,
            BranchID: warehouse.BranchID,
            WarehouseID: warehouse.WarehouseID,
            Address: warehouse.WarehouseAddress,
            Name : warehouse.WarehouseName,  
            Stock : warehouse.QtyEnd,  
            CityID: warehouse.CityOngkirID,
            CityOngkirID: warehouse.CityOngkirID,
            CityName : warehouse.CityName,
            ProvinceID: warehouse.ProvinceID,
            ProvinceName: warehouse.ProvinceName
        })
        changeIsOpenWarehouse(false);
    }

    function getAvailableStock(){
        
        var urlencoded = new URLSearchParams();
        urlencoded.append("type", "Ecommerce_Available_Stock");
        urlencoded.append("row", 1);

        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/configuration`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }
    async function initConfig(){
        let response = await getAvailableStock();
        if(response && response.status == 200){
            setAvailStockConfig(response.data);
        }
    }
    useEffect(()=>{
        initConfig();
        setWarehouses(props.warehouses);
        console.log(props.warehouses)
    },[props.warehouses]);
    return (
        <div className='warehouse-container'>
            {
                warehouses.map((warehouse, index)=>{
                    return(
                        <div className="shipping-container">
                            {/* <div className="detail-header">Warehouse</div> */}
                            <div style={{marginBottom:"20px"}}>
                                <div className="shipping-info-container" style={{padding:"10px"}}>
                                    <div className="shipping-information-header">{warehouse.WarehouseName} {(warehouse.Note && warehouse.Note == "RECOMMENDED") ? <RecommendIcon/> : <></>}</div>
                                    {(availableStockConfig.Value == 1) ? <div className="shipping-information-header">Stock: {warehouse.QtyEnd}</div> : <></>}
                                    <div></div>
                                    <div>{warehouse.WarehouseAddress}, {warehouse.CityName}, {warehouse.ProvinceName}, Indonesia</div>
                                    <hr/>
                                    <div className="right-align">
                                        {
                                            (warehouse.QtyEnd > 0)?
                                            (
                                                <button className={`btn ${THEME_COLOR}`} onClick={ ()=> ClickWarehouse(warehouse) } >Select</button>
                                            ):
                                            (
                                                <button className={`btn disabled`}>Out Of Stock</button>
                                            )
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
}

export default Warehouse;